const ɵ0 = { scope: "patient" };
export class WebviewerModule {
}
export { ɵ0 };
